export enum ShippingLocationModeCode {
  Jobsite = 'JOBSITE',
  PointOfDelivery = 'POD',
}

export interface ShippingLocationMode {
  desc: string;
  code: ShippingLocationModeCode;
}
